module.exports = __webpack_public_path__ + "static/media/logo.377a7b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 1325
// module chunks = 0